import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-569edb76"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "cms-flex--between mg-b--15"
};
const _hoisted_2 = {
  class: "cms-page-title"
};
const _hoisted_3 = {
  class: "check-film-warp"
};
const _hoisted_4 = {
  class: "left-warp"
};
const _hoisted_5 = {
  class: "cms-card-block"
};
const _hoisted_6 = {
  class: "video-name"
};
const _hoisted_7 = {
  class: "name"
};
const _hoisted_8 = {
  class: "video-list"
};
const _hoisted_9 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_10 = {
  key: 0,
  style: {
    "display": "flex"
  }
};
const _hoisted_11 = {
  class: "flex-a-center"
};
const _hoisted_12 = {
  class: "subtitle"
};
const _hoisted_13 = {
  class: "title"
};
const _hoisted_14 = {
  class: "subtitle-list"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "result"
};
const _hoisted_17 = {
  class: "blod"
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  class: ""
};
const _hoisted_20 = {
  class: "right-warp"
};
const _hoisted_21 = {
  class: "right_header"
};
const _hoisted_22 = {
  class: "check-warp cms-card-block"
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = {
  style: {
    "color": "#222930",
    "font-size": "16px",
    "margin-bottom": "20px"
  }
};
const _hoisted_26 = {
  key: 2
};
const _hoisted_27 = {
  style: {
    "color": "#222930",
    "font-size": "16px",
    "margin-bottom": "20px"
  }
};
const _hoisted_28 = {
  key: 0,
  style: {
    "text-align": "center",
    "margin-bottom": "20px"
  }
};
const _hoisted_29 = {
  style: {
    "color": "#222930",
    "font-size": "16px"
  }
};
const _hoisted_30 = {
  key: 2,
  style: {
    "text-align": "center",
    "margin-bottom": "20px"
  }
};
const _hoisted_31 = {
  style: {
    "color": "#222930",
    "font-size": "16px",
    "margin-bottom": "20px"
  }
};
import Buttons from '@/components/Buttons/index.vue';
import TagType from '../components/TagType/index.vue';
import MediaPlay from '../../Components/MediaPlay/index.vue';
import { usePageConfig } from '@/utils/useComponentConfig';
import { useI18n } from 'vue-i18n';
import { elMessage, getTextWidth } from '@/utils';
import { inject, onMounted, onUnmounted } from 'vue';
import { debounce } from '@/utils/tools';
import { getCurrentTime } from '@/utils/timeFormat';
import { handleCopy } from '@/utils/clipboard';
import { AUDIT_COLOR_NEW, AUDIT_STATUS_NEW } from '@/assets/config/dicts';
import { batchAuditStatusApi, getMovieInfoApi, getDramaInfoApi } from '@/api/vodNew';
import { useVodLanguages } from '@/utils/cacheData';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    detailInfo: {
      type: Object,
      default: () => {}
    },
    auditStatus: {
      type: String,
      default: ''
    }
  },
  emits: ['onBack', 'to-edit', 'update-list'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const seasonOptions = ref([]);
    const Tags = ref([]);
    const broadCastList = inject('broadCastList');
    const FormRef = ref();
    const resonFormRef = ref();
    const checkTableRef = ref();
    const batchTableRef = ref();
    const mediaPlayRef = ref(null);
    const mediaList = ref(); // 接口返回所有电影数据

    const alltvEpisodesList = ref([]); // 接口返回的所有剧集数据

    const languageOptions = ref([]); // 获取所有语言

    const getAllLanguages = async () => {
      const res = await useVodLanguages();
      languageOptions.value = res;
    }; // 单个审批弹窗


    const dialogConfig = reactive({
      visible: false,
      action: 'audited',
      config: {
        title: ''
      },
      confirm: done => {
        const ids = checkTableConfig.data[checkTableConfig.rowSelectIndex].id;

        if (dialogConfig.action === 'not_approved') {
          resonFormRef.value.validate(valid => {
            if (valid) {
              batchOperation([ids], 'not_approved', done, dramaOrMovieData.postData.reason.trim());
            }
          });
        } else if (dialogConfig.action === 'terminal_audit') {
          batchOperation([ids], 'terminal_audit', done);
        } else if (dialogConfig.action === 'audited') {
          batchOperation([ids], 'audited', done);
        }
      }
    }); // 批量审批弹窗

    const batchDialogConfig = reactive({
      visible: false,
      action: 'not_approved',
      config: {
        title: ''
      },
      confirm: done => {
        const ids = selectTableConfig.data.map(item => item.id);

        if (batchDialogConfig.action === 'not_approved') {
          FormRef.value.mForm.validate(async valid => {
            if (valid) {
              batchOperation(ids, 'not_approved', done, actionForm.formData.reason.trim());
            }
          });
        } else if (batchDialogConfig.action === 'terminal_audit') {
          batchOperation(ids, 'terminal_audit', done);
        } else if (batchDialogConfig.action === 'audited') {
          batchOperation(ids, 'audited', done);
        }
      }
    }); // 审核接口调用

    const batchOperation = async (ids, action, done, remark) => {
      try {
        let params = {
          auditStatus: action,
          mediaIdList: ids,
          programType: props.detailInfo.programType,
          remark,
          releaseStatus: dramaOrMovieData.checked ? 'online' : '',
          programId: props.detailInfo.id
        };
        const res = await batchAuditStatusApi(params);

        if (res.code == '0') {
          elMessage('success', '操作成功');
          checkTableRef.value && checkTableRef.value.commonTableRef.clearSelection();
          dialogConfig.visible = false;
          batchDialogConfig.visible = false;
          dramaOrMovieData.postData.reason = '';
          dramaOrMovieData.checked = false;
          dramaOrMovieData.anew = false;
          getTableList();
          setTimeout(() => {
            done();
          }, 500);
        } else {
          done();
        }
      } catch (error) {
        console.log('298-error', error);
        done();
      }
    }; // 格式化分辨率显示文字


    const getRatioType = val => {
      const item = broadCastList.value.filter(item => {
        return item.type === val;
      });
      return item && item[0].broadCastType;
    };

    const back = () => {
      emit('onBack');
      emit('update-list');
    }; // tag组件点击事件


    const onTagClick = debounce((item, index) => {
      if (index === dramaOrMovieData.currentActive) return;
      tableConfig.data = [];
      dramaOrMovieData.subtitleList = [];
      dramaOrMovieData.url = '';
      handleDestroyVideo();
      checkTableConfig.rowSelectIndex = 0;
      checkTableConfig.paginationConfig.page = 1;
      tableConfig.rowSelectIndex = 0;
      dramaOrMovieData.currentActive = index;
      checkTableRef.value.commonTableRef.clearSort();
      getTableList(true);
    }, 500);
    const tableConfig = reactive({
      data: [],
      rowSelectIndex: 0,
      isCardBlock: false,
      isShowHeader: false,
      maxHeight: 200,
      headerButtonsList: [{
        label: '终端审核中',
        type: 'info',
        disabled: true,
        controller: btn => {
          return checkTableConfig.data[checkTableConfig.rowSelectIndex].auditStatus == 'terminal_audit';
        },
        func: () => {}
      }, {
        label: '终端审核',
        type: 'success',
        func: () => {
          dialogConfig.config.title = '终端审核';
          dialogConfig.action = 'terminal_audit';
          dialogConfig.visible = true;
        },
        controller: btn => {
          return checkTableConfig.data[checkTableConfig.rowSelectIndex].auditStatus != 'terminal_audit';
        }
      }, {
        label: '审核通过',
        type: 'primary',
        disabled: false,
        func: () => {
          dialogConfig.config.title = '审核通过';
          dialogConfig.action = 'audited';
          dialogConfig.visible = true;
        },
        controller: btn => {
          btn.disabled = checkTableConfig.data[checkTableConfig.rowSelectIndex].auditStatus == 'audited';
          return true;
        }
      }, {
        label: '审核不通过',
        type: 'danger',
        disabled: false,
        func: () => {
          dialogConfig.config.title = '审核不通过';
          dialogConfig.action = 'not_approved';
          dialogConfig.visible = true;
        },
        controller: btn => {
          btn.disabled = checkTableConfig.data[checkTableConfig.rowSelectIndex].auditStatus == 'not_approved';
          return true;
        }
      }]
    });
    const columnConfig = reactive({
      columnList: [{
        label: '编码标准',
        prop: 'videoCode'
      }, {
        label: '分辨率',
        prop: 'videoResolution' // formatter: (val) => {
        //     if (val) {
        //         return getRatioType(val);
        //     }
        // }

      }, {
        label: 'URL',
        prop: 'playUrl',
        cellSlot: true,
        showOverflowTooltip: false
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        buttonsList: [{
          label: '播放',
          func: debounce(row => {
            dramaOrMovieData.url = '';
            dramaOrMovieData.videoWarpLoading = true;
            setTimeout(() => {
              dramaOrMovieData.videoWarpLoading = false;
              dramaOrMovieData.url = row.url;
            }, 200);
            tableConfig.rowSelectIndex = row.index;
          }, 500)
        }]
      }]
    }); // 判断数组每一项的某一个属性的值是否一样

    const hasSameValue = arr => {
      if (arr.length === 0) return false;
      if (arr.length === 1) return true;
      const firstItemState = arr[0].auditStatus;
      let num = 0;

      for (let i = 1; i < arr.length; i++) {
        if (arr[i].auditStatus === firstItemState) num++;
      }

      return num === arr.length - 1 ? true : false;
    }; // 判断选中是否存在上线


    const hasOnline = arr => {
      if (arr.length === 0) return false;
      let idx = arr.findIndex(item => item.releaseStatus == 1);
      return idx > -1 ? true : false;
    }; // 右侧table表格配置


    const checkTableConfig = reactive({
      showLoading: false,
      paginationConfig: usePageConfig(),
      rowSelectIndex: 0,
      data: [],
      isCardBlock: false,
      showPageBar: false,
      isShowHeader: false,
      headerButtonsList: [{
        label: '编辑影片',
        type: 'warning',
        func: () => {
          emit('onBack');
          emit('to-edit', props.detailInfo, {
            pageFrom: 'CheckFilm'
          });
        },
        controller: btn => {
          return props.detailInfo.releaseStatus == 'online' ? false : true;
        }
      }, {
        label: '批量终端审核',
        type: 'success',
        disabled: false,
        func: () => {
          if (selectTableConfig.data.length === 0) {
            return elMessage('warning', '请先勾选需要批量操作的影片');
          }

          if (hasSameValue(selectTableConfig.data)) {
            batchDialogConfig.config.title = '终端审核';
            batchDialogConfig.visible = true;
            batchDialogConfig.action = 'terminal_audit';
          } else {
            return elMessage('warning', '请先勾选状态相同的影片');
          }
        },
        controller: btn => {
          btn.disabled = hasSameValue(selectTableConfig.data) && selectTableConfig.data[0].auditStatus === 'terminal_audit' || hasOnline(selectTableConfig.data) ? true : false;
          return true;
        }
      }, {
        label: '批量通过',
        type: 'primary',
        disabled: false,
        func: () => {
          if (selectTableConfig.data.length === 0) {
            return elMessage('warning', '请先勾选需要批量操作的影片');
          }

          if (hasSameValue(selectTableConfig.data)) {
            batchDialogConfig.config.title = '审核通过';
            batchDialogConfig.visible = true;
            batchDialogConfig.action = 'audited';
          } else {
            return elMessage('warning', '请先勾选状态相同的影片');
          }
        },
        controller: btn => {
          btn.disabled = hasSameValue(selectTableConfig.data) && selectTableConfig.data[0].auditStatus === 'audited' || hasOnline(selectTableConfig.data) ? true : false;
          return true;
        }
      }, {
        label: '批量不通过',
        type: 'danger',
        disabled: false,
        func: () => {
          if (selectTableConfig.data.length === 0) {
            return elMessage('warning', '请先勾选需要批量操作的影片');
          }

          if (hasSameValue(selectTableConfig.data)) {
            batchDialogConfig.config.title = '审核不通过';
            batchDialogConfig.visible = true;
            batchDialogConfig.action = 'not_approved';
          } else {
            return elMessage('warning', '请先勾选状态相同的影片');
          }
        },
        controller: btn => {
          btn.disabled = hasSameValue(selectTableConfig.data) && selectTableConfig.data[0].auditStatus === 'not_approved' || hasOnline(selectTableConfig.data) ? true : false;
          return true;
        }
      }],
      'row-key': 'id'
    });
    const checkColumnConfig = reactive({
      columnList: [{
        label: '',
        type: 'selection',
        'reserve-selection': true
      }, {
        label: '影片名称',
        prop: 'name'
      }, {
        label: '剧集编号',
        prop: 'sequence',
        sortable: 'custom',
        controller: () => {
          return props.detailInfo.programType === 'movie' ? false : true;
        }
      }, {
        label: '审核状态',
        prop: 'auditStatus',
        cellSlot: true
      }, {
        label: '上传时间',
        prop: 'createTime',
        formatter: val => val && getCurrentTime(val)
      }, {
        label: '备注',
        prop: 'auditRemark'
      }]
    });
    const selectTableConfig = reactive({
      paginationConfig: usePageConfig(),
      data: [],
      isCardBlock: false,
      isShowHeader: false,
      name: ''
    });
    const selectColumnConfig = reactive({
      columnList: [{
        label: '影片名称',
        prop: 'name'
      }, {
        label: '剧集编号',
        prop: 'sequence',
        sortable: true,
        controller: () => {
          return props.detailInfo.programType === 'movie' ? false : true;
        }
      }, {
        label: '上传时间',
        prop: 'createTime',
        formatter: val => val && getCurrentTime(val)
      }]
    });

    const validatorReason = (rule, value, callback) => {
      if (value && value.trim() == '') {
        return callback(new Error('输入不能为空'));
      }

      callback();
    };

    const actionForm = reactive({
      formList: [[{
        label: '原因',
        prop: 'reason',
        widgetType: 'textarea',
        required: false,
        maxlength: 100,
        showWordLimit: true,
        autosize: true,
        colspan: 3,
        placeholder: t('请输入审核不通过原因')
      }]],
      formData: {
        reason: ''
      },
      rules: {
        reason: [{
          validator: validatorReason,
          trigger: 'blur'
        }, {
          max: 100,
          message: t('限制字符数量', {
            num: '100'
          })
        }]
      }
    });

    const getDetailInfo = async (id, language) => {
      dramaOrMovieData.url = '';
      dramaOrMovieData.leftWarpLoading = true;

      try {
        //console.log('props.detailInfo.programType', props.detailInfo.programType)
        if (props.detailInfo.programType === 'movie') {
          // 拿对应的电影url数据
          let targetList = mediaList.value.filter(item => item.audioLanguage == language); // 根据语言找到对应的播放url

          tableConfig.data = targetList.length ? targetList[0].mediaContentList : [];
          dramaOrMovieData.url = targetList.length ? targetList[0].mediaContentList[0].playUrl : undefined;
        } else {
          // 电视剧数据
          let targetList = alltvEpisodesList.value ? alltvEpisodesList.value.filter(item => item.id == id) : []; // 左侧表单数据

          tableConfig.data = targetList.length ? targetList[0].mediaContentList : []; // 左侧播放链接

          dramaOrMovieData.url = targetList.length ? targetList[0].mediaContentList[0].playUrl : undefined; // 左侧字幕

          dramaOrMovieData.subtitleList = targetList.length ? targetList[0].subtitleList : [];
        }
      } catch (error) {
        console.log('601-err', error);
      }

      dramaOrMovieData.leftWarpLoading = false;
    };

    const getTableList = async (isFirst, otherParams) => {
      //todo: otherParams点击右侧表格排序的时候会有排序参数，接口没有对应的排序功能
      checkTableConfig.rowSelectIndex = 0;
      dramaOrMovieData.anew = false;
      checkTableConfig.showLoading = true;
      const language = Tags.value.length > 0 && Tags.value[dramaOrMovieData.currentActive].language || '';
      let defaultLanguage = '';

      if (props.detailInfo.programType === 'movie') {
        try {
          // 影片的右侧列表请求
          const res = await getMovieInfoApi({
            movieId: props.detailInfo.id,
            infoType: 1
          });

          if (res.code == '0') {
            // 右侧tags
            Tags.value = res.data.map(item => {
              return {
                audioLanguage: item.audioLanguage
              };
            });
            defaultLanguage = Tags.value.length > 0 && Tags.value[dramaOrMovieData.currentActive].audioLanguage || ''; // 右侧表格数据用对应语言的mediaList

            let targetList = res.data ? res.data.filter(item => item.audioLanguage == defaultLanguage) : [];
            dramaOrMovieData.name = targetList.length ? targetList[0].name : '';
            checkTableConfig.data = targetList.length ? targetList : [];
            checkTableConfig.paginationConfig.total = targetList.length ? targetList.length : 0; // 记录全部的mediaList数据

            mediaList.value = res.data ? res.data : []; // 左侧字幕

            dramaOrMovieData.subtitleList = res.data[0].subtitleList;
          }

          checkTableConfig.data.length && getDetailInfo(props.detailInfo.id, defaultLanguage);

          if (!checkTableConfig.data.length) {
            dramaOrMovieData.subtitleList = [];
            tableConfig.data = [];
            dramaOrMovieData.url = '';
            handleDestroyVideo();
          }
        } catch (error) {
          console.log(error, '667-----');
        }
      } else {
        // 剧集的右侧列表请求
        try {
          const res = await getDramaInfoApi({
            tvSeriesId: props.detailInfo.id
          });

          if (res.code == '0') {
            // 右侧tags
            Tags.value = res.data.map(item => {
              return { ...item,
                audioLanguage: item.audioLanguage
              };
            });
            defaultLanguage = Tags.value.length > 0 && Tags.value[dramaOrMovieData.currentActive].audioLanguage || ''; // 季

            seasonOptions.value = Tags.value.length ? Tags.value[dramaOrMovieData.currentActive].tvSeasonList.map(item => {
              return { ...item,
                label: `Season ${item.sequence}`
              };
            }) : []; // 默认选取第一项

            dramaOrMovieData.currentSeasonId = seasonOptions.value.length ? seasonOptions.value[0].id : undefined; // 右侧表格数据用对应seasonId的tvEpisodesList 712行

            let targetList = Tags.value[dramaOrMovieData.currentActive].tvSeasonList.filter(item => item.id == dramaOrMovieData.currentSeasonId);
            let tvEpisodesList = targetList.length ? targetList[0].tvEpisodesList : [];
            dramaOrMovieData.name = tvEpisodesList.length ? tvEpisodesList[0].name : '';
            checkTableConfig.data = tvEpisodesList.length ? tvEpisodesList : [];
            checkTableConfig.paginationConfig.total = tvEpisodesList.length ? tvEpisodesList.length : 0; // 记录全部的tvSeasonMediaList数据

            res.data.forEach(tag => {
              tag.tvSeasonList.forEach(season => {
                // seasonId: 可根据此ID找到对应的右侧列表数据
                season.tvEpisodesList.forEach(episode => episode.seasonId = season.id);
                alltvEpisodesList.value.push(...season.tvEpisodesList);
              });
            }); // 左侧字幕

            let currentSubtitleList = [];
            tvEpisodesList.forEach(item => {
              currentSubtitleList.push(...item.subtitleList);
            });
            dramaOrMovieData.subtitleList = currentSubtitleList;

            if (isFirst && res.data.length > 0) {
              // 默认索引为0的TvEpisodesList的id
              let defaultTvEpisodesListId = tvEpisodesList[0] ? tvEpisodesList[0].id : undefined;
              getDetailInfo(defaultTvEpisodesListId, defaultLanguage);
            } else {
              res.data.length && getDetailInfo('', defaultLanguage);

              if (!checkTableConfig.data.length) {
                dramaOrMovieData.subtitleList = [];
                tableConfig.data = [];
                dramaOrMovieData.url = '';
                handleDestroyVideo();
              }
            }
          }
        } catch (error) {
          console.log('err-709', error);
        }
      }

      checkTableConfig.showLoading = false;
    }; // 季下拉选项改变事件


    const onSeasonChange = seasonId => {
      console.log('season', seasonId);
      dramaOrMovieData.currentSeasonId = seasonId; // 此处逻辑与712行相同
      // 右侧表格数据用对应seasonId的tvEpisodesList

      let targetList = Tags.value[dramaOrMovieData.currentActive].tvSeasonList.filter(item => item.id == dramaOrMovieData.currentSeasonId);
      let tvEpisodesList = targetList.length ? targetList[0].tvEpisodesList : [];
      dramaOrMovieData.name = tvEpisodesList.length ? tvEpisodesList[0].name : '';
      checkTableConfig.data = tvEpisodesList.length ? tvEpisodesList : [];
      checkTableConfig.paginationConfig.total = tvEpisodesList.length ? tvEpisodesList.length : 0; // 左侧字幕

      let currentSubtitleList = [];
      tvEpisodesList.forEach(item => {
        currentSubtitleList.push(...item.subtitleList);
      });
      dramaOrMovieData.subtitleList = currentSubtitleList; // 右侧表格默认激活第0项

      checkTableConfig.rowSelectIndex = 0; // 默认索引为0的TvEpisodesList的id

      let defaultTvEpisodesListId = tvEpisodesList[0] ? tvEpisodesList[0].id : undefined;
      getDetailInfo(defaultTvEpisodesListId, Tags.value[dramaOrMovieData.currentActive].audioLanguage);
    };

    const handleSelectionChange = val => {
      selectTableConfig.data = JSON.parse(JSON.stringify(val));
    };

    const dramaOrMovieData = reactive({
      currentSubtitleIndex: 0,
      currentSeasonId: undefined,
      postData: {
        reason: ''
      },
      leftWarpLoading: false,
      rightWarpLoading: false,
      videoWarpLoading: false,
      currentActive: 0,
      subtitleList: [],
      name: '',
      url: '',
      auditStatus: -1,
      remark: '',
      anew: false,
      checked: false
    }); // 右侧审核列表table行点击事件

    const handleCheckTableRowClick = debounce((row, col, event) => {
      tableConfig.rowSelectIndex = 0;
      const language = Tags.value.length > 0 && Tags.value[dramaOrMovieData.currentActive].audioLanguage || '';
      dramaOrMovieData.anew = false;
      checkTableConfig.rowSelectIndex = row.index;
      dramaOrMovieData.name = row.name;
      getDetailInfo(row.id, language);
    }, 500); // 字幕item点击事件

    const handleSubtitleItemClick = debounce(index => {
      dramaOrMovieData.currentSubtitleIndex = index;
    }, 500); // 重新审核按钮点击事件

    const handleAnew = () => {
      dramaOrMovieData.anew = true;
    }; // 表格排序


    const handleSortChange = debounce(async params => {
      tableConfig.rowSelectIndex = 0;
      checkTableConfig.rowSelectIndex = 0;

      if (params.order) {
        const sortType = params.order.replace('ending', '');
        getTableList(true, {
          sortType,
          sortByField: params.prop
        });
      } else {
        getTableList(true);
      }
    }, 500);

    const handleDestroyVideo = () => {
      // 销毁视频组件
      mediaPlayRef.value && mediaPlayRef.value.destroyVideo();
    }; // 复制URL


    const copyUrl = (url, event, className) => {
      if (className) {
        let target = document.querySelector('.' + className);
        const width = getTextWidth(target.innerText, {
          fontSize: '14px'
        });
        if (target.offsetWidth < width + 80) return;
      }

      handleCopy(url, event);
    }; //  内容超出时显示提示


    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText, {
        fontSize: '14px'
      });
      tipDisabled.value = target.offsetWidth < width + 80;
    };

    const displayTextTip = e => {
      tipDisabled.value = false;
      return;
    };

    onMounted(() => {
      getAllLanguages();
      getTableList(true);
    });
    onUnmounted(() => {
      handleDestroyVideo();
    });
    watch(() => dialogConfig.visible, val => {
      resonFormRef.value && resonFormRef.value.resetFields();
      FormRef.value && FormRef.value.mForm.resetFields();
      dramaOrMovieData.checked = false;
    });
    watch(() => batchDialogConfig.visible, val => {
      batchTableRef.value && batchTableRef.value.commonTableRef.clearSort();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_MPopper = _resolveComponent("MPopper");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_MDialog = _resolveComponent("MDialog");

      const _component_FormTable = _resolveComponent("FormTable");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("header", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('影片内容审核')), 1), _createVNode(_component_el_button, {
        class: "cms-op-btn cms-op-btn-main",
        onClick: back
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('返回')), 1)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(MediaPlay, {
        style: {
          "width": "576px",
          "height": "328px"
        },
        url: dramaOrMovieData.url,
        ref_key: "mediaPlayRef",
        ref: mediaPlayRef
      }, null, 8, ["url"])])), [[_directive_loading, dramaOrMovieData.videoWarpLoading]]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('影片名称')) + ": ", 1), _createElementVNode("span", _hoisted_7, _toDisplayString(dramaOrMovieData.name), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_common_table, {
        style: {
          "width": "100%"
        },
        showPagination: false,
        "table-config": tableConfig,
        rowSelectIndex: tableConfig.rowSelectIndex
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [scope.column.property == 'playUrl' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_MPopper, {
            disabled: tipDisabled.value,
            placement: "top",
            trigger: "hover"
          }, {
            reference: _withCtx(() => [_createElementVNode("div", {
              onMouseover: showTextTip,
              class: _normalizeClass('url-span-' + scope.row.index),
              style: {
                "display": "inline-block",
                "white-space": "nowrap",
                "width": "100%",
                "overflow": "hidden",
                "text-overflow": "ellipsis"
              }
            }, [_createElementVNode("span", null, _toDisplayString(scope.row.playUrl), 1), scope.row.playUrl ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onMouseover: _withModifiers(displayTextTip, ["stop"]),
              class: "cms-op-btn-non-focus",
              onClick: $event => copyUrl(scope.row.playUrl, $event, 'url-span-' + scope.row.index),
              style: {
                "width": "60px",
                "margin-left": "20px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('复制')), 1)]),
              _: 2
            }, 1032, ["onMouseover", "onClick"])) : _createCommentVNode("", true)], 34)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, _toDisplayString(scope.row.playUrl), 1), _createVNode(_component_el_button, {
              class: "cms-op-btn-non-focus",
              onClick: $event => copyUrl(scope.row.playUrl, $event),
              style: {
                "margin-left": "20px"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('复制')), 1)]),
              _: 2
            }, 1032, ["onClick"])])]),
            _: 2
          }, 1032, ["disabled"])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "rowSelectIndex"]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('字幕')), 1), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dramaOrMovieData.subtitleList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["subtitle-item", dramaOrMovieData.currentSubtitleIndex === index ? 'is-subtitle-select' : '']),
          key: index,
          onClick: $event => _unref(handleSubtitleItemClick)(index)
        }, _toDisplayString(item.language), 11, _hoisted_15);
      }), 128))])])]), checkTableConfig.data.length > 0 && (checkTableConfig.data[checkTableConfig.rowSelectIndex].auditStatus === 'unaudited' || checkTableConfig.data[checkTableConfig.rowSelectIndex].auditStatus === 'terminal_audit' || dramaOrMovieData.anew) ? (_openBlock(), _createBlock(Buttons, {
        key: 0,
        class: "buttons",
        buttonsList: tableConfig.headerButtonsList
      }, null, 8, ["buttonsList"])) : _createCommentVNode("", true)])]), checkTableConfig.data.length > 0 && checkTableConfig.data[checkTableConfig.rowSelectIndex].auditStatus !== 'unaudited' && checkTableConfig.data[checkTableConfig.rowSelectIndex].auditStatus !== 'terminal_audit' && !dramaOrMovieData.anew ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "check-result",
        style: _normalizeStyle('background-color:' + (checkTableConfig.data[checkTableConfig.rowSelectIndex].auditStatus === 'audited' ? '#f5faf8' : ''))
      }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('审核结果')) + ":", 1), _createElementVNode("span", {
        class: "error-text",
        style: _normalizeStyle('color:' + (checkTableConfig.data[checkTableConfig.rowSelectIndex].auditStatus === 'audited' ? '#3aaf81' : ''))
      }, _toDisplayString(checkTableConfig.data[checkTableConfig.rowSelectIndex].auditStatus === 'audited' ? _ctx.$t('已通过审核') : checkTableConfig.data[checkTableConfig.rowSelectIndex].auditStatus === 'not_approved' ? _ctx.$t('未通过审核') : _unref(AUDIT_STATUS_NEW)[checkTableConfig.data[checkTableConfig.rowSelectIndex].auditStatus]), 5)]), checkTableConfig.data[checkTableConfig.rowSelectIndex].auditStatus === 'not_approved' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('原因')) + ":", 1), _createElementVNode("span", null, _toDisplayString(checkTableConfig.data[checkTableConfig.rowSelectIndex].remark), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_button, {
        disabled: checkTableConfig.data[checkTableConfig.rowSelectIndex].releaseStatus === 'audited',
        onClick: handleAnew,
        class: "green-btn cms-op-btn cms-op-btn-main"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('重新审核')), 1)]),
        _: 1
      }, 8, ["disabled"])])], 4)) : _createCommentVNode("", true)])), [[_directive_loading, dramaOrMovieData.leftWarpLoading]]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(TagType, {
        modelValue: Tags.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => Tags.value = $event),
        onOnTagClick: _unref(onTagClick),
        "current-active": dramaOrMovieData.currentActive,
        "show-add-button": false,
        languageOptions: languageOptions.value
      }, null, 8, ["modelValue", "onOnTagClick", "current-active", "languageOptions"]), _createVNode(Buttons, {
        class: "buttons",
        buttonsList: checkTableConfig.headerButtonsList,
        style: {
          "margin-bottom": "10px"
        }
      }, null, 8, ["buttonsList"])]), _createElementVNode("div", _hoisted_22, [__props.detailInfo.programType === 'tv_series' ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: _ctx.$t('选择季'),
        style: {
          "width": "240px",
          "margin-bottom": "10px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: dramaOrMovieData.currentSeasonId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dramaOrMovieData.currentSeasonId = $event),
          filterable: "",
          placeholder: "Select",
          size: "large",
          onChange: onSeasonChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seasonOptions.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.label,
              value: item.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createBlock(_component_common_table, {
        ref_key: "checkTableRef",
        ref: checkTableRef,
        onSelectionChange: handleSelectionChange,
        onRowClick: _unref(handleCheckTableRowClick),
        onSortChange: _unref(handleSortChange),
        rowSelectIndex: checkTableConfig.rowSelectIndex,
        style: {
          "width": "100%"
        },
        "table-config": checkTableConfig,
        "pagination-config": checkTableConfig.paginationConfig,
        render: () => getTableList(false)
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": checkColumnConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [_createElementVNode("div", {
            style: _normalizeStyle('color:' + _unref(AUDIT_COLOR_NEW)[scope.row.auditStatus])
          }, _toDisplayString(_unref(AUDIT_STATUS_NEW)[scope.row.auditStatus]), 5)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["onRowClick", "onSortChange", "rowSelectIndex", "table-config", "pagination-config", "render"])), [[_directive_loading, checkTableConfig.showLoading]])])])]), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => dialogConfig.visible = $event),
        nativeConfig: {
          width: '25%',
          top: '20vw',
          closeOnClickModal: false
        },
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [dialogConfig.action === 'not_approved' ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_el_form, {
          model: dramaOrMovieData.postData,
          ref_key: "resonFormRef",
          ref: resonFormRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "reason",
            rules: [{
              validator: validatorReason,
              trigger: 'blur'
            }, {
              max: 100,
              message: _ctx.$t('限制字符数量', {
                num: '100'
              }),
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              style: {
                "width": "100%"
              },
              placeholder: _ctx.$t('请输入审核不通过原因'),
              maxlength: 100,
              modelValue: dramaOrMovieData.postData.reason,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dramaOrMovieData.postData.reason = $event),
              "show-word-limit": "",
              type: "textarea"
            }, null, 8, ["placeholder", "modelValue"])]),
            _: 1
          }, 8, ["rules"])]),
          _: 1
        }, 8, ["model"])])) : _createCommentVNode("", true), dialogConfig.action === 'audited' ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('确认影片通过审核？')), 1), __props.auditStatus === 'audited' ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 0,
          modelValue: dramaOrMovieData.checked,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dramaOrMovieData.checked = $event),
          label: _ctx.$t('是否直接上线影片'),
          size: "large"
        }, null, 8, ["modelValue", "label"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), dialogConfig.action === 'terminal_audit' ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('确认将影片终端审核？')), 1)])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"]), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: batchDialogConfig.visible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => batchDialogConfig.visible = $event),
        nativeConfig: {
          closeOnClickModal: false
        },
        dialogConfig: batchDialogConfig.config,
        onOnConfirm: batchDialogConfig.confirm
      }, {
        default: _withCtx(() => [batchDialogConfig.action === 'not_approved' ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_FormTable, {
          ref_key: "FormRef",
          ref: FormRef,
          col: ['20%', '30%', '20%', '30%'],
          "form-list": actionForm.formList,
          "form-data": actionForm.formData,
          formRules: actionForm.rules
        }, null, 8, ["form-list", "form-data", "formRules"])])) : _createCommentVNode("", true), batchDialogConfig.action === 'audited' ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["mg-b--20", __props.auditStatus === 'audited' ? 'flex-sb-center' : 'flex-ja-center'])
        }, [_createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('确认将以下影片通过审核？')), 1), __props.auditStatus === 'audited' ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 0,
          modelValue: dramaOrMovieData.checked,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => dramaOrMovieData.checked = $event),
          label: _ctx.$t('是否直接上线影片'),
          size: "large"
        }, null, 8, ["modelValue", "label"])) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true), batchDialogConfig.action === 'terminal_audit' ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('确认将以下影片终端审核？')), 1)])) : _createCommentVNode("", true), _createVNode(_component_common_table, {
          ref_key: "batchTableRef",
          ref: batchTableRef,
          style: {
            "width": "100%"
          },
          showPagination: false,
          "table-config": selectTableConfig
        }, {
          default: _withCtx(() => [_createVNode(_component_column, {
            "column-list": selectColumnConfig.columnList
          }, null, 8, ["column-list"])]),
          _: 1
        }, 8, ["table-config"])]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"])]);
    };
  }

});